import { useState, useEffect } from "react";
import "./css/gallery.css";
import PropTypes from "prop-types";
import DrawingsModal from "../modals/drawingsModal/DrawingsModal";

const Gallery = ({ images, data = true }) => {

  const [showModal, setShowModal] = useState(false);
  const [paintData, setPaintData] = useState(null);

  const handleOpenDrawingModal = (data) => {
    setShowModal(true);
    setPaintData(data);
  };

  return (
    <div className="container">
      <div className="row g-3 justify-content-center">
        {images.map((img) => (
          <div
            key={img.id}
            className="col-6 col-sm-6 col-md-auto cursor-pointer"
            onClick={() => handleOpenDrawingModal(img)}
          >
            <div className="position-relative overflow-hidden rounded-4 gallery-item">
              <img src={img.img} alt={img.alt} className="img-fluid" />
              {data && (
                <div className="overlay d-flex flex-column justify-content-center align-items-center text-white text-center px-3">
                  <div className="color-text-gris-28-hv">
                    {img.title.replace(/ (\S+)$/, "\u00A0$1")}
                  </div>
                  <div className="color-text-14-gallery-h">
                    {img.technique.replace(/ (\S+)$/, "\u00A0$1")}
                  </div>
                  <div className="color-text-14-gallery-h">{img.measures}</div>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

      {showModal && paintData && (
        <DrawingsModal
          key={paintData.id} 
          drawing={paintData}
          onClose={() => setShowModal(false)}
        />
      )}
    </div>
  );
};

Gallery.propTypes = {
  images: PropTypes.any,
  data: PropTypes.bool,
};

export default Gallery;
